import { useForm } from "@mantine/form";
import { useAuth } from "../context/AuthContext";
import {
  PasswordInput,
  Select,
  TextInput,
  Button,
  LoadingOverlay,
} from "@mantine/core";
import PageHeader from "../components/common/PageHeader";
import { createHrUser } from "../api/hrUserApi";
import {
  creationNotification,
  samePhoneNumberErroNotif,
} from "../utils/useNotification";
import styled from "styled-components";
import Container from "../components/common/Container";
import {
  combineValidators,
  validateMaxLength,
  validateMinLength,
  validateNoSpaces,
  validatePhoneNumberIsNumeric,
  validatePhoneNumberStartsWithZero,
  validateRequired,
} from "../utils/validations";
import { useNavigate } from "react-router";
import { useRef, useState } from "react";
import PlusIcon from "../components/common/Icons/PlusIcon";
import CustomLoadingOverlay from "../components/common/CustomLoadingOverlay";

const NewPanelUser = () => {
  const { user, company } = useAuth();
  const navigate = useNavigate();
  const formRef = useRef<HTMLFormElement>(null);
  const [isLoading, setIsLoading] = useState(false);

  const form = useForm({
    initialValues: {
      name: "",
      phone: "",
      password: "",
      privilege: null,
    },
    validate: {
      name: validateRequired,
      phone: combineValidators(
        validateRequired,
        validatePhoneNumberStartsWithZero,
        validatePhoneNumberIsNumeric,
        validateNoSpaces,
        validateMinLength(11)
      ),
      password: combineValidators(
        validateRequired,
        validateMaxLength(16),
        validateMinLength(4)
      ),
      privilege: (value: any) => (value ? null : "Bu alan zorunludur"),
    },
  });

  const handleSubmit = async (values: object) => {
    if (user) {
      setIsLoading(true);
      try {
        const { data, response }: any = await createHrUser({
          ...values,
        });
        if (data?.success) {
          creationNotification("Panel Kullanıcısı", data.success);
          setIsLoading(false);
          form.reset();
          return;
        }

        if (response?.data?.error === "This phone number is being used") {
          samePhoneNumberErroNotif();
          setIsLoading(false);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  return (
    <Container>
      <PageHeader
        pageTitle="Yeni Panel Kullanıcısı Kaydı"
        isButtoned
        buttonText="Oluştur"
        buttonIcon={<PlusIcon />}
        buttonOnClick={() => formRef.current?.requestSubmit()}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "40px",
          width: "min-content",
        }}
      >
        <form
          ref={formRef}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "15px",
            width: "468px",
          }}
          onSubmit={form.onSubmit(handleSubmit)}
        >
          <TextInput
            label="Şirket Kodu"
            value={company?.code}
            radius={10}
            size="md"
            readOnly
          />
          <TextInput
            label="Ad Soyad"
            placeholder="Ad Soyad Giriniz."
            radius={10}
            size="md"
            {...form.getInputProps("name")}
            maxLength={40}
          />
          <Select
            label="Yetki"
            placeholder="Yetki Seçiniz"
            radius={10}
            size="md"
            data={[
              { value: "admin", label: "Admin" },
              { value: "user", label: "User" },
            ]}
            {...form.getInputProps("privilege")}
            value={form.values.privilege || null}
          />
          <TextInput
            label="Telefon"
            placeholder="05*********"
            radius={10}
            size="md"
            maxLength={11}
            {...form.getInputProps("phone")}
          />
          <PasswordInput
            label="Şifre"
            placeholder="Şifre Giriniz."
            radius={10}
            size="md"
            maxLength={16}
            {...form.getInputProps("password")}
          />
        </form>
      </div>
      <CustomLoadingOverlay visible={isLoading} />
    </Container>
  );
};

export default NewPanelUser;

const PageTitle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  gap: 12px;
`;

const Title = styled.div`
  font-size: 24px;
  font-weight: 600;
  line-height: 24px;
  color: black;
`;

const TitleSubText = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  color: #828282;
`;
